import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TournamentCard from '../pages/Tournaments/components/TournamentCard';

interface Tournament {
  _id: string;
  name: string;
  sport: string;
  ageCategories: string[];
  startDate: string;
  location: string;
  status: 'upcoming' | 'ongoing' | 'completed';
  image?: string;
  thumbnail?: string; // Add thumbnail field
  registeredTeams?: number;
  maxTeams?: number;
  injuredPlayers?: number;
  isTeamRegistered?: boolean; // Add the isTeamRegistered field
}

interface TournamentSectionProps {
  title: string;
  tournaments: Tournament[];
  type: 'upcoming' | 'ongoing';
  viewAllLink: string;
}

const TournamentSection: React.FC<TournamentSectionProps> = ({ 
  title, 
  tournaments, 
  type, 
  viewAllLink 
}) => {
  const navigate = useNavigate();

  const handleViewDetails = (tournamentId: string) => {
    navigate(`/tournaments/${tournamentId}`);
  };

  const handleRegisterNow = (tournamentId: string) => {
    navigate(`/tournaments/${tournamentId}/register`);
  };

  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">{title}</h4>
        <Button 
          variant="link" 
          className="text-decoration-none p-0"
          onClick={() => navigate(viewAllLink)}
        >
          View all <i className="ph-arrow-right ms-1"></i>
        </Button>
      </div>
      
      <Row>
        {tournaments.length > 0 ? (
          tournaments.slice(0, 3).map((tournament, index) => (
            <Col lg={4} md={6} key={tournament._id} className="mb-3">
              <div className="d-flex justify-content-center">
                <TournamentCard
                  tournament={{
                    _id: tournament._id,
                    name: tournament.name,
                    shortName: tournament.name,
                    logo: tournament.image || '',
                    thumbnail: tournament.thumbnail, // Pass thumbnail field
                    location: tournament.location,
                    startDate: tournament.startDate,
                    endDate: tournament.startDate, // Using startDate as fallback
                    status: tournament.status,
                    sports: tournament.sport,
                    ageCategories: tournament.ageCategories,
                    isTeamRegistered: tournament.isTeamRegistered // Pass the new field
                  }}
                  onViewDetails={() => handleViewDetails(tournament._id)}
                  onRegisterNow={() => handleRegisterNow(tournament._id)}
                  showRegisterButton={type === 'upcoming'}
                  activeTab={type === 'upcoming' ? 'upcoming' : 'registered'}
                  index={index}
                />
              </div>
            </Col>
          ))
        ) : (
          <Col lg={12}>
            <div className="text-center py-4">
              <i className="ph-trophy text-muted" style={{ fontSize: '3rem' }}></i>
              <p className="text-muted mt-2">No {type} tournaments available</p>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default TournamentSection; 